import RestService from "./restService";
import { CLOCK_RECORDS } from "../../url";

const singleton = Symbol();
const singletonEnforcer = Symbol();

class ClockRecordService extends RestService {
  constructor(enforcer) {
    super(CLOCK_RECORDS);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Clock Records RestService");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new ClockRecordService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default ClockRecordService;
